<template>
    <section class="d-flex flex-column h-full">
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar>
        <div class="flex-grow-1 scroll-y">
            <div class="pda-default">
                <div class="t-headline5">
                    {{$t('15')}} 
                    <!-- 계정찾기 -->
                </div>
                <router-view></router-view>
            </div>
        </div>

        
    </section>
</template>

<script>
/**
 * 아이디 찾기 메인 컴포넌트(find account main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'

export default {
    name: 'findcode',
    data() {
        return {
            
        }
    },
    components: {
        TopAppBar
    },

    watch: {
        '$route' (to, from) {
            if (to.name === 'FindCodeStep1') {
                this.setTopAppBarCloseOnly('')
            }else if (to.name === 'FindCodeComplete') {
                this.setTopAppBarCloseOnlyMoveLogin('')
            }else {
                this.setTopAppBarBackOnly('')
            }
        }
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.setTopAppBarCloseOnly()
    },

    methods: {
        setTopAppBarBackOnly(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarCloseOnly(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },
    }
}
</script>